import React, { useEffect, useState, useCallback } from "react";
import "./ComoRewards.scss";
import { IconButton, Button } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import noImg from "../../../../js/assets/images/no-image.svg";
import noRewardImg from "../../../../js/assets/images/no-reward-img.png";
import comoReward from "../../../../js/assets/images/como-reward.png";
import { useTranslation } from "react-i18next";
import { freezOff } from "../../../../../redux-store/action";
import axios from "axios";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../../redux-store/store";

const ComoRewards = () => {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  const {setComoRewards} = bindActionCreators(actionCreators, appDispatch);
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [rewards, setRewards] = useState([]);
  const [rewardKeys, setRewardKeys] = useState([])
  const [selectedRewards, setSelectedRewards] = useState([])
  const [cartTotal, setCartTotal] = useState(0)
  const [someOfProducts, setSomeOfProducts] = useState([])
  const { cart, formData } = appState;

  // Memoized function to prepare the payload
  const preparePayload = useCallback(() => {
    if (!cart || cart.length === 0) return { orders: [], total_amount: 0 };
    console.log(cart, 'cart');
    const orderData = cart.map(order => ({
      product_id: order?.product_id,
      product_name: order?.prod_title?.en,
      category_id: order?.category_id,
      category_name: order?.category_name?.en,
      quantity: order?.quantity,
      amount: Number(order?.total) * Number(order?.quantity),
    }));

    const sumOfSameProduct = orderData.reduce((acc, curr) => {
      const existing = acc.find(item => item.product_id === curr.product_id);
      if (existing) {
        existing.quantity += curr.quantity;
        existing.amount += curr.amount;
      } else {
        acc.push(curr);
      }
      return acc;
    }, []);
    setSomeOfProducts(sumOfSameProduct);
    console.log('sumOfSameProduct', sumOfSameProduct);


    const totalAmount = orderData.reduce((sum, order) => sum + order.amount, 0);
    setCartTotal(totalAmount);
    return {
      mobile_no: "96566666666",
      device_id: appState.deviceId,
      total_amount: totalAmount,
      orders: orderData,
    };
  }, [cart, appState.deviceId]);

  // Function to get Como item payload
 const getComoItemPayload = (benefit, key) => {
    console.log(cart,'benefit', benefit);
    
    // Find the corresponding product in cart based on product_id
    const cartItem = cart?.find(item => item.product_id == benefit.product_id);
    
    return {
        discount: benefit.discount,
        product_id: benefit.product_id,
        quantity: benefit.quantity,
        gross_amount: benefit.grossAmount,
        net_amount: benefit.grossAmount - benefit.discount,
        product_name: cartItem?.prod_title?.en || '',
        category_id: cartItem?.category_id || null,
        category_name: cartItem?.category_name?.en || ''
    };
};

  // Optimized API call function
  const handleGetComboReward = useCallback(async () => {
    try {
      setLoading(true);
      const payload = preparePayload();
      
      console.log('API Payload:', payload);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/como/get_benefits?branch=2`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const rewardsData = response?.data?.data || [];
      console.log(response?.data?.data,'response?.data?.data');
      const formattedRewards = Object.entries(rewardsData).map(([key, reward]) => ({
        sumOfDiscount: Math.abs(reward.benefits.reduce((acc, curr) => acc + curr.discount, 0)).toFixed(3),
        status: true,
        disabled: false,
        id: key, // Using the dynamic key from the object as ID
        image: comoReward, // Default image since none exists in API
        title: reward.name,
        description: `Discount applied across ${reward.benefits.length} product(s)`, // Custom description
        comoItems: reward.benefits.map(benefit => (getComoItemPayload(benefit, key))),
      }));
      console.log('Formatted Rewards:', formattedRewards);

      setRewards(formattedRewards);
    } catch (error) {
      console.error("API Error:", error);
      appDispatch({
        type: "SHOW_ALERT",
        alertType: "warning",
        message: error.response?.data?.message || "Please check your network.",
      });
    } finally {
      setLoading(false);
      appDispatch(freezOff());
    }
  }, [preparePayload, appDispatch]);


const handleApply = (rewardId) => {
  setSelectedRewards(prev => {
    // Find the complete reward object from rewards array
    const rewardToAdd = rewards.find(reward => reward.id === rewardId);
    
    // Check if already exists in selected rewards
    const exists = prev.some(reward => reward.id === rewardId);
    
    return exists
      ? prev.filter(reward => reward.id !== rewardId) // Remove if exists
      : [...prev, rewardToAdd]; // Add full reward object if not exists
  });
};

const calculateTotalDiscount = () => {
  return selectedRewards.reduce((total, reward) => {
    // Convert sumOfDiscount string to number (e.g., "10.000" → 10)
    const discountValue = parseFloat(reward.sumOfDiscount) || 0;
    return total + discountValue;
  }, 0).toFixed(3);
};

  useEffect(() => {
    handleGetComboReward();
  }, [handleGetComboReward]);

  

  useEffect(() => {
  console.log(selectedRewards, 'selectedRewards');
  }, [selectedRewards])
  
  
  const handleCheckoutPage = () => {
      let comoRewardDetails ={
        comoItems: selectedRewards.map(reward => reward.comoItems).flat(),
        totalDiscount: Number(calculateTotalDiscount()).toFixed(3),
        totalAmount: Number(cartTotal - calculateTotalDiscount()).toFixed(3),
        cartTotal: Number(cartTotal).toFixed(3),
        someOfProducts: someOfProducts,
        comoDeal: selectedRewards.map(reward => ({
          key: reward.id,
          appliedAmount: Number(reward.sumOfDiscount).toFixed(3),
        }))
      }
      setComoRewards(comoRewardDetails);
    history.push('/checkout')
  }
  return (
    <section id="como-rewards">
      <div className="rewards-container">
        <section id="topNav">
          <div className="row m-0 align-items-center">
            <IconButton
              aria-label="back"
              className={appState.langValue === "ar" ? "backBtnAr" : "backBtn2"}
              onClick={() => history.goBack()}
            >
              {appState.langValue === "ar" ? (
                <ArrowForwardIosIcon style={{ padding: 0 }} fontSize="inherit" />
              ) : (
                <ArrowBackIosIcon fontSize="inherit" />
              )}
            </IconButton>
            <div className="pl-1 mt-2">
              <h4>
                <strong>{t("My Rewards")}</strong>
              </h4>
            </div>
          </div>
        </section>

        <div className="rewards-grid mt-4 " >
          {loading
            ? [1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="reward-card skeleton">
                  <div className="reward-img-container skeleton-img"></div>
                  <div className="reward-content">
                    <div className="reward-title skeleton-text"></div>
                    <div className="reward-description skeleton-text"></div>
                    <div className="apply-button skeleton-button"></div>
                  </div>
                </div>
              ))
            : rewards.map((reward) => (
                <div
                  key={reward.id}
                  className={`reward-card ${reward.disabled ? "disabled" : ""}`}
                >
                  <div className="reward-img-container">
                    <img
                      src={reward.image}
                      className="reward-img"
                      alt="Reward"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noRewardImg;
                      }}
                    />
                  </div>
                  <div className="reward-content">
                    <h3 className="reward-title">{reward.title}
                      <p></p>
                    </h3>
                    <p className="reward-description">{reward.sumOfDiscount} KWD </p>
                   <Button
                    variant="contained"
                    className={`apply-button ${
                      selectedRewards.some(r => r.id === reward.id) ? "active" : ""
                    }`}
                    disabled={reward.disabled}
                    onClick={() => handleApply(reward.id)}
                  >
                    { "Apply Reward"}
                  </Button>
                  </div>
                </div>
              ))}
           <div className="reward-summary">
        <div className="summary-item">
          <span className="summary-label">Total Cart Amount:</span>   
          <span className="summary-value">{cartTotal.toFixed(3)} KWD</span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Total Discount:</span>
          <span className="summary-value">
            {calculateTotalDiscount()} KWD
          </span>
        </div>
        <div className="summary-item">
          <span className="summary-label">Total Amount After Discount:</span>
          <span className="summary-value">
            {(cartTotal - calculateTotalDiscount()).toFixed(3)} KWD
          </span>
        </div>
        
        <Button 
          variant="contained" 
          className={`confirm-button ${selectedRewards?.length > 0 ? "active" : ""}`} 
          disabled={!selectedRewards?.length > 0}
          onClick={handleCheckoutPage}
        >
          Confirm
        </Button>
      </div>
        </div>
      </div>
    </section>
  );
};

export default ComoRewards;